import { EntityType, compareArrays } from '@frontend/common';
import { UserGroupClient } from '@frontend/group/api';
import { GroupMember, IGroup } from '@frontend/group/types';
import { CommonMessage } from '@frontend/lang';
import { updateField } from '@frontend/repository';
import { MultiUserGroupSelect } from '@frontend/user/select';

import UpdateModal from '../../../../modal/update-modal/update-modal.component';
import { useUpdateGroupModal } from './update-group-modal.controller';

const USER_GROUP_FORM_ID = 'update-user-groups-form';

export interface UpdateGroupModalProps {
    groups: IGroup[];
    members: GroupMember[];
    entity_id: string;
    callback?: () => void;
}

export const UpdateGroupModal = (props: UpdateGroupModalProps) => {
    const viewProps = useUpdateGroupModal(props);
    return (
        <UpdateModal<GroupMember[], { groups: string[] }>
            onSubmit={async (value) => {
                const { add, remove } = compareArrays(
                    props.groups.map((g) => g.id),
                    value.groups
                );
                const results = await Promise.all([
                    ...add.map((group_id) =>
                        UserGroupClient.postUserGroupMember(viewProps.currentAccount, group_id, {
                            entity_id: props.entity_id,
                            entity_type: EntityType.USER
                        })
                    ),
                    ...remove.map((group_id) =>
                        UserGroupClient.deleteUserGroupMember(viewProps.currentAccount, group_id, props.members.find((m) => m.group_id === group_id)!.id)
                    )
                ]);
                props.callback && props.callback();
                return Promise.resolve(results.filter((r) => r !== undefined) as GroupMember[]);
            }}
            formId={USER_GROUP_FORM_ID}
            order={[]}
            label={CommonMessage.BUTTONS.EDIT(CommonMessage.OBJECTS.USER_GROUP.DEFAULT)}
            type={EntityType.USER_GROUP}
            values={{ groups: viewProps.userGroups }}
            append={
                <MultiUserGroupSelect
                    value={viewProps.userGroups}
                    onChange={(v) => {
                        viewProps.setUserGroups(v);
                        viewProps.dispatch(updateField({ formId: USER_GROUP_FORM_ID, key: 'groups', value: v }));
                    }}
                />
            }
        />
    );
};
